import React from 'react';
import fonts from "../fonts.json";

export const Head = () => {
  return (
    <>
      {fonts.map((font) => (
        <link key={font} href={font} rel="stylesheet" />
      ))}
    </>
  );
};
